import { getBreadcrumbsItems } from '@wix/thunderbolt-commons'
import { BreadcrumbsClientTrail } from '@wix/thunderbolt-components-native'
import { ViewerModel } from '@wix/thunderbolt-symbols'
import type { ICurrentRouteInfo, IPagesMap } from 'feature-router'
import type { BreadcrumbsPageConfig, BreadcrumbsProps } from './types'

type GetBreadcrumbs = (
	currentRouteInfo: ICurrentRouteInfo,
	pagesMap: IPagesMap,
	viewerModel: ViewerModel,
	pageConfig: BreadcrumbsPageConfig,
	props: BreadcrumbsProps
) => BreadcrumbsClientTrail | undefined

export const getBreadcrumbs: GetBreadcrumbs = (currentRouteInfo, pagesMap, viewerModel, pageConfig, props) => {
	const currentUrl = currentRouteInfo.getCurrentUrlWithoutQueryParams()
	const currentInfo = currentRouteInfo.getCurrentRouteInfo()

	if (currentUrl && currentInfo) {
		const routeInfo = {
			currentUrl: decodeURI(currentUrl), // in case if URL uses non-english characters
			currentPage: pagesMap.getPageById(currentInfo.pageId),
			homePageHref: viewerModel.site.externalBaseUrl,
		}

		return getBreadcrumbsItems(routeInfo, pageConfig, props)
	}
}
